import React, { useEffect } from 'react'
import {
    useReactTable,
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    flexRender,
} from '@tanstack/react-table'
import Pagination from "./pagination";
import DebouncedInput from "Components/Forms/DebouncedInput";

const filterTableGeneric = (row, columnId, values, addMeta) => {

    let searchValues = values.split(/(\s+)/).filter(e => e.trim().length > 0);

    return searchValues.every((value) => {
        return Object.values(row.original).join(" ").toLowerCase().includes(value.toLowerCase());
    });
}

const ReactTableGeneric = ({ data, columns, filters, tableClassName, rowCount = 20, filterRecords, count, emptyMessage = "Geen data beschikbaar" }) => {

    const [globalFilter, setGlobalFilter] = React.useState('')
    const [sorting, setSorting] = React.useState([])
    const [pageSize, setPageSize] = React.useState(rowCount);

    const tableClass = tableClassName || "mb-0 table table-bordered table-sm table-striped table-hover";
    const { search = true, columnFilter = false, pagination = true, columnSorting = true } = filters || {};
    const fuzzyFilter = filterRecords ?? filterTableGeneric;

    const pointerStyles = {
        cursor: 'pointer',
        userSelect: 'none',
    }

    const table = useReactTable({
        data: data,
        columns,
        count: count,
        state: {
            sorting,
            globalFilter,
        },
        onSortingChange: setSorting,
        onGlobalFilterChange: setGlobalFilter,
        globalFilterFn: fuzzyFilter,
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        getSortedRowModel: getSortedRowModel(),
    })

    useEffect(() => {
        table.setPageSize(pageSize)
    }, [pageSize]);

    //   useEffect(() => {
    //     table.setPageSize(pageSize)
    // }, [pageSize]);

    return (
        <div>
            {search ? <div className="form-group pull-right mb-0">
                <DebouncedInput
                    value={globalFilter ?? ''}
                    onChange={value => setGlobalFilter(String(value))}
                    className="form-control mb-2 search"
                    placeholder="Zoeken..." />
            </div> : null}


            <table className={tableClass}>
                <thead>
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map(header => (
                                <th
                                    key={header.id}
                                    style={{
                                        width: header.column.getSize(),
                                    }}
                                >
                                    {header.isPlaceholder
                                        ? null
                                        : (
                                            <div
                                                {...{
                                                    style: header.column.getCanSort()
                                                        ? pointerStyles
                                                        : undefined,
                                                    onClick: header.column.getToggleSortingHandler(),
                                                }}
                                            >
                                                <span key={header.id}>
                                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                                </span>

                                                {
                                                    {
                                                        asc: ' 🔼',
                                                        desc: ' 🔽',
                                                    }[header.column.getIsSorted()] ?? null}
                                            </div>
                                        )}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {
                        table.getRowModel().rows.length ?
                            table.getRowModel().rows.map(row => (
                                <tr key={row.id} >
                                    {row.getVisibleCells().map(cell => (
                                        <td
                                            key={cell.id}
                                            style={{
                                                width: cell.column.getSize(),
                                            }}
                                        >
                                            <span key={String(cell.getValue())}>
                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                            </span>
                                        </td>
                                    ))}
                                </tr>
                            ))
                            : <tr><td colSpan={columns?.length} align='center' style={{ textAlign: "center" }}>{emptyMessage}</td></tr>
                    }
                </tbody>

            </table>
            {pagination ? <Pagination table={table} /> : null}
        </div>
    )
}

export default ReactTableGeneric;
